
import analytics from '~/mixins.js/analytics'
import accordion from '~/mixins.js/accordion'

export default {
  props: {
    mode: {
      type: String
    },
    isHidden: {
      type: Boolean,
      default: true
    },
    eventName: {
      type: String,
      default: 'Show FAQ Question'
    },
    tabId: {
      type: String
    }
  },
  mixins: [analytics, accordion],
  methods: {
    toggle () {
      this.toggleContent()
      this.onShow()
    },
    onShow () {
      const question = this.$slots.question[0].text.trim()
      this.trackEvent(this.eventName, question)
    }
  }
}
